import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { ConstantsService } from '../../constant/constants.service';
import { MissionPlace } from 'src/app/shared/models/mission/mission-place';
import { GenericCrudService } from '../../generic-crud.service';
import { HttpParams } from '@angular/common/http';
import { ListingResponse } from 'src/app/shared/models/listing/listing-response';

@Injectable({
	providedIn: 'root'
})
export class MissionPlaceService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	/**
	 * Renvoi la liste de toute les missionPlace
	 * @returns
	 */
	getMissionPlaces(): Observable<MissionPlace[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.missionPlaceUrl}s`,
			'getMissionPlaces'
		);
	}

	/**
	 * Renvoi la liste de toute les missionPlace
	 * @returns
	 */
	getMissionPlacesPage(
		page: number,
		size: number,
		search: string,
		specialties: string
	): Observable<ListingResponse> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append('page', page);
		queryParams = queryParams.append('size', size);
		if (search) {
			queryParams = queryParams.append('search', search);
		}
		if (specialties) {
			queryParams = queryParams.append('specialty', specialties);
		}

		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.missionPlaceUrl}/page`,
			'getMissionPlacesPage',
			httpOptions
		);
	}

	/**
	 * Renvoi la liste de toute les missionPlace avec des infos minimales (id, nom, nom affiché)
	 * @returns
	 */
	getMissionPlacesMinimal(): Observable<MissionPlace[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.missionPlaceUrl}s/minimal`,
			'getMissionPlaces'
		);
	}

	/**
	 * Renvoi une missionPlace en fonction de son id
	 * @param missionPlaceId
	 * @returns
	 */
	getMissionPlaceById(missionPlaceId: number): Observable<MissionPlace> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.missionPlaceUrl}/${missionPlaceId}`,
			'getMissionPlaceById'
		);
	}

	importMissionPlaces(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'missionPlaces.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionPlaceUrl}/import`,
			`importMissionPlaces`,
			formData
		);
	}

	/**
	 * Met à jour une missionPlace
	 * @param missionPlace
	 * @returns
	 */
	updateMissionPlace(missionPlace: MissionPlace): Observable<string> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.missionPlaceUrl}`,
			`updateMissionPlace`,
			missionPlace
		);
	}

	/**
	 * Ajoute une missionPlace
	 * @param missionPlace
	 * @returns
	 */
	addMissionPlace(missionPlace: MissionPlace): Observable<string> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionPlaceUrl}`,
			`addMissionPlace`,
			missionPlace
		);
	}

	/**
	 * Supprime une missionPlace
	 * @param missionPlaceId
	 * @returns
	 */
	deleteMissionPlace(missionPlaceId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.missionPlaceUrl}/${missionPlaceId}`,
			`deleteMissionPlace`
		);
	}
}
